import React from 'react';

/**
 * Topbar heart icon — 24px stroke-only outline heart used for the favorites
 * placeholder slot.
 */
const IconHeart = props => (
  <svg
    className={props.className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 21s-7-4.35-9.33-9A5.5 5.5 0 0 1 12 6.5a5.5 5.5 0 0 1 9.33 5.5C19 16.65 12 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconHeart;
